<div class="project-modal">
  <header class="project-modal-header">
    <h2>{{ 'popins.duplicate.title' | translate }}</h2>
    <p>{{ 'popins.duplicate.info' | translate }}</p>
  </header>

  <div>
    <p class="custom-form-row" [class.error]="currentError > 0">
      <label for="input-duplicate-name">{{ 'popins.duplicate.label1' | translate }}</label>
      <input type="text" [(ngModel)]="projectName" id="input-duplicate-name" autocorrect="off" spellcheck="false" />
    </p>
    <p class="form-message-error" *ngIf="currentError > 0">
      {{ 'popins.duplicate.error_' + currentError | translate }}
    </p>
  </div>

  <div class="project-modal-actions">
    <ng-casto-button
      class="secondary"
      (click)="cancel()"
      [label]="'generic.cancel' | translate"
      [hidden]="isLoading"></ng-casto-button>
    <ng-casto-button
      class="primary"
      (click)="submit()"
      [label]="'generic.duplicate' | translate"
      [loading]="isLoading"></ng-casto-button>
  </div>
</div>
